module.exports = __webpack_public_path__ + "img/growthAbility2.f5fde800.png";